<template>
  <div class="orderPage">
    <div class="search_wrap flex-between">
      <van-field v-model="params.order_id" placeholder="输入订单号查找→" />
      <div class="search_btn flex-rowc" @click="handleSearch">
        <i class="iconfont icon-chazhaotubiao"></i>
      </div>
    </div>
    <div class="select_wrap">
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="params.returntype"
          :options="returntypeOption"
          @change="changeDropdownStatus"
        />
        <van-dropdown-item
          v-model="params.returncheck"
          :options="returncheckOption"
          @change="changeDropdownProperty"
        />
      </van-dropdown-menu>
    </div>
    <div class="flex-between">
      <div class="radio_wrap flex-rowc">
        <van-checkbox
          v-model="checked"
          shape="square"
          checked-color="#ee0a24"
          @change="changeCheck"
        ></van-checkbox>
        <span>按筛选条件只看今天的订单</span>
      </div>
      <div class="clear_condition" @click="handleClearParams">
        清空筛选条件
        <!-- 清空筛选条件（显示所有订单） -->
      </div>
    </div>

    <div class="order_wrap" @scroll="orderScroll($event)">
      <div class="list" v-if="dataList.length > 0">
        <div
          class="item"
          v-for="item in dataList"
          :key="item.id"
          @click="handleDetail(item.order_id)"
        >
          <div class="block_one">
            <div class="column flex-rowl">
              <p class="label">创建时间：</p>
              <p class="con">{{ getTiemSplit(item.create_time) }}</p>
            </div>
            <div class="column flex-rowl">
              <p class="label">订单状态：</p>
              <p class="con">
                {{
                  item.service_order_status == 1
                    ? "待接单"
                    : item.service_order_status == 2
                    ? "已接单"
                    : item.service_order_status == 3
                    ? "取餐中"
                    : item.service_order_status == 4
                    ? "送餐中"
                    : item.service_order_status == 5
                    ? "待自提"
                    : item.service_order_status == 6
                    ? "已送达"
                    : "已完成"
                }}
              </p>
            </div>
            <div class="column flex-rowl">
              <p class="label">订单情况：</p>
              <p class="con">
                {{
                  item.service_order_property == 1
                    ? "服务订单进行中"
                    : item.service_order_property == 2
                    ? "服务订单取消申请中"
                    : item.service_order_property == 3
                    ? "服务订单已取消"
                    : "服务订单已完成"
                }}
              </p>
            </div>
          </div>
          <div class="block_two">
            <div class="column flex-between">
              <div class="left flex-rowl">
                <p class="label">服务订单号：</p>
                <p class="con">
                  {{ item.service_order_id }}
                </p>
              </div>
              <div
                class="btn_copy code"
                :data-clipboard-text="item.service_order_id"
                @click="handleCopy()"
              >
                <i class="iconfont icon-fuzhi"></i>
              </div>
            </div>
            <div class="column flex-between">
              <div class="left flex-rowl">
                <p class="label">订单号：</p>
                <p class="con">
                  {{ item.order_id }}
                </p>
              </div>
              <div
                class="btn_copy code"
                :data-clipboard-text="item.order_id"
                @click="handleCopy()"
              >
                <i class="iconfont icon-fuzhi"></i>
              </div>
            </div>
            <div class="column flex-rowl">
              <p class="label">送餐位置：</p>
              <p class="con">{{ item.address_detail }}</p>
            </div>
            <div class="column flex-rowl">
              <p class="label">关联取餐柜：</p>
              <p class="con">{{ item.service_rating }}</p>
            </div>
            <div class="column flex-rowl">
              <p class="label">用户姓名：</p>
              <p class="con">{{ item.truename }}</p>
            </div>
            <div class="column flex-rowl">
              <p class="label">联系电话：</p>
              <p class="con">{{ item.customer_phone }}</p>
            </div>
            <div class="column flex-rowl">
              <p class="label">订单内容：</p>
              <p class="con">{{ item.order_content }}</p>
            </div>
          </div>
          <div class="block_three">
            <div class="column flex-rowl">
              <p class="label">投诉原因：</p>
              <p class="con red">{{item.complaint_reason}}</p>
            </div>
            <div class="column_img flex-rowl" v-if="item.piceArr.length > 0">
              <div class="img_box flex-rowc" v-for="(itemChild, indexChild) in item.piceArr" :key="indexChild">
                <img :src="itemChild">
                <!-- <i class="iconfont icon-zhaoxiangji"></i> -->
              </div>
            </div>
            <div class="column flex-rowl">
              <p class="label">申请退款类型：</p>
              <p class="con">{{item.returntype == 1 ? '全额退款' : '仅退返订单费用'}}</p>
            </div>
            <div class="column flex-rowl">
              <p class="label">退款申请审核状态：</p>
              <p class="con">{{item.returncheck == 0 ? '待审核' : item.returncheck == 1 ? '同意' : '不同意'}}</p>
            </div>
          </div>
        </div>
      </div>
      <van-empty
        description="暂无订单"
        v-if="!isLoading && dataList.length == 0"
      />
    </div>
  </div>
</template>

<script>
import { getScoldList, getToken } from "../api/api";
import Clipboard from "clipboard";

export default {
  name: "orderComplain",
  data() {
    return {
      show: false,
      // 服务订单状态
      returntypeOption: [
        {
          text: "所有退款类型",
          value: "",
        },
        {
          text: "全额退款",
          value: 1,
        },
        {
          text: "仅退返订单费用	",
          value: 2,
        },
      ],
      // 服务订单属性
      returncheckOption: [
        {
          text: "所有审核状态",
          value: "",
        },
        {
          text: "待审核",
          value: 0,
        },
        {
          text: "同意",
          value: 1,
        },
        {
          text: "不同意	",
          value: 2,
        },
      ],

      checked: true,
      params: {
        Page: 1,
        token: "",
        PageSize: 10,
        order_id: "",
        returntype: "",
        returncheck: "",
        istoday: 1, // 1 是 0 否
      },

      isLoading: true,
      total: 0,
      dataList: [],
    };
  },
  created() {
    this.getToken();
  },
  computed: {
    getTiemSplit() {
      return function (data) {
        // let newData = data.split('T')[0] + ' ' + data.split('T')[1]
        let newData = data.replace("T", " ");
        return newData;
      };
    },
  },
  methods: {
    // 获取token
    getToken() {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.params.token = res.data.token;
          this.getScoldList();
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    //
    getScoldList() {
      let { params } = this;
      getScoldList(params).then((res) => {
        this.total = res.total;
        res.list.forEach(v => {
          v.piceArr = v.complaint_pic.replace(/"/g,'').split(',')
        })
        this.dataList = this.dataList.concat(...res.list);
        this.isLoading = false;
      });
    },
    handleDetail(id) {
      this.$router.push(`/complainIndex/complainDetail/${id}`);
    },

    // 滚动事件
    orderScroll(e) {
      let el = e.target;
      //判断是否到达div容器底部
      let { total, dataList } = this;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
        // if (listTotal > dataList.length) {
        //   this.params.Page += 1;
        //   this.initData();
        // }
        if (total > dataList.length) {
          this.params.Page += 1;
          this.getScoldList();
        }
      }
    },
    handleSearch() {
      this.params.Page = 1;
      this.dataList = [];
      this.getScoldList();
    },
    changeCheck(e) {
      this.params.istoday = e ? 1 : 0;
      this.params.Page = 1;
      this.dataList = [];
      this.getScoldList();
    },
    changeDropdownStatus(e) {
      console.log(e, "=========");
      this.params.service_order_status = e;
      this.params.Page = 1;
      this.dataList = [];
      this.getScoldList();
    },
    changeDropdownProperty(e) {
      console.log(e, "=========");
      this.params.service_order_property = e;
      this.params.Page = 1;
      this.dataList = [];
      this.getScoldList();
    },
    // onConfirmState(e) {
    //   let { text, value } = e;
    //   this.orserState = text;
    //   this.params.service_order_status = value;
    //   this.show = false;
    //   this.params.Page = 1;
    //   this.dataList = [];
    //   this.getOrderList();
    // },
    // onConfirmProperty(e) {
    //   let { text, value } = e;
    //   this.orderProperty = text;
    //   this.params.service_order_property = value;
    //   this.show = false;
    //   this.params.Page = 1;
    //   this.dataList = [];
    //   this.getOrderList();
    // },
    handleClearParams() {
      this.params.order_id = "";
      this.params.service_order_status = "";
      this.params.service_order_property = "";
      this.params.istoday = 0;
      this.params.Page = 1;
      this.dataList = [];
      this.getScoldList();
    },
    /**
     * 复制功能
     */
    handleCopy() {
      var clipboard = new Clipboard(".code");
      console.log(clipboard, "=====clipboard");
      clipboard.on("success", (e) => {
        console.log("复制成功", e);
        this.$toast({
          message: "复制成功",
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast({
          message: "手机权限不支持复制功能",
        });
        console.log("该浏览器不支持自动复制", e);
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang='less' scoped>
.orderPage {
  padding-top: 40px;
  .search_wrap {
    width: 660px;
    height: 80px;
    border: 1px solid rgba(173, 173, 173, 0.76);
    border-radius: 45px;
    margin: auto;
    background: #ffffff;
    padding: 0 20px;
    box-sizing: border-box;
    margin-bottom: 25px;
    /deep/ .van-cell {
      padding: 0;
      background: none;
      flex-shrink: 0;
      border: none;
      flex: 1;
    }
    /deep/ .van-field__control {
      text-align: center;
    }
    .search_btn {
      flex-shrink: 0;
      width: 70px;
      .iconfont {
        font-size: 40px;
        color: #d6d0d1;
      }
    }
  }
  .select_wrap {
    width: 660px;
    margin: auto;
    .select_item {
      margin-top: 20px;
      height: 80px;
      border-bottom: 1px dashed #2c2b2b;
      font-size: 30px;
      color: #333333;
      padding: 0 14px;
      .icon-toTop {
        transform: rotate(180deg);
        font-size: 20px;
      }
    }
    /deep/ .van-dropdown-menu__bar {
      box-shadow: none;
    }
    /deep/ .van-dropdown-menu__title {
      width: 280px;
      box-sizing: border-box;
      text-align: center;
      padding: 0 30px 0 15px;
    }
    /deep/ .van-dropdown-menu__title::after {
      right: 20px;
      border-color: transparent transparent #c4c5c6 #c4c5c6;
    }
  }
  .radio_wrap {
    font-size: 24px;
    color: #1e1e1e;
    margin: 25px auto;
    span {
      margin-left: 16px;
    }
  }
  .clear_condition {
    width: 200px;
    height: 60px;
    background: #ffffff;
    border: 3px solid #096f70;
    border-radius: 35px;
    margin: auto;
    font-size: 24px;
    color: #096f70;
    text-align: center;
    line-height: 60px;
  }
  .order_wrap {
    margin-top: 25px;
    height: 67vh;
    overflow-y: scroll;
    .list {
      .item {
        width: 660px;
        min-height: 700px;
        background: #ffffff;
        border: 6px solid #e6e6e6;
        border-radius: 40px;
        margin: 0 auto 30px;
        padding: 52px 44px 0;
        box-sizing: border-box;
        font-size: 28px;
        color: #040000;
        .block_one {
          font-size: 30px;
          margin-bottom: 45px;
          .column {
            &:nth-child(2n) {
              margin: 10px 0;
            }
            .label {
              width: 140px;
            }
            .con {
              color: #ff0000;
            }
          }
        }
        .block_two {
          // margin-bottom: 99px;
          font-size: 28px;
          .column {
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        .block_three {
          font-size: 30px;
          margin-top: 45px;
          margin-bottom: 60px;
          .label {
            width: auto !important;
          }
          .con {
            &.red {
              color: #ff0000;
            }
          }
          .column_img {
            margin: 43px 0;
            .img_box {
              width: 150px;
              height: 150px;
              background: #dcdcdc;
              overflow: hidden;
              &:nth-child(2) {
                margin: 0 30px;
              }
              .iconfont {
                font-size: 70px;
                color: #7e7e7e;
              }
            }
          }
        }
        .column {
          align-items: flex-start;
          &:nth-child(2n) {
            margin: 26px 0;
          }
          .left {
            align-items: flex-start;
            .con {
              width: 320px;
              flex-shrink: 0;
            }
          }
          .label {
            white-space: nowrap;
            width: 180px;
            flex-shrink: 0;
          }
          .con {
            word-wrap: break-word;
            flex-shrink: 0;
            width: 380px;
            span {
              margin-left: 10px;
            }
          }
          .iconfont {
            font-size: 30px;
          }
        }
      }
    }
  }
  /deep/ .van-popup--bottom {
    bottom: 80px;
  }
}
</style>